import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OtherDealsPopup = _resolveComponent("OtherDealsPopup")!
  const _component_PopupDialog = _resolveComponent("PopupDialog")!
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_p_toast = _resolveComponent("p-toast")!
  const _component_app_fullscreen_spinner = _resolveComponent("app-fullscreen-spinner")!
  const _component_app_company_status_dialog = _resolveComponent("app-company-status-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_OtherDealsPopup),
    _createVNode(_component_PopupDialog),
    _createVNode(_component_ConfirmPopup),
    _createElementVNode("div", {
      class: _normalizeClass(["layout", { '_overflow-clear': _ctx.overflowClear }])
    }, [
      _createVNode(_component_router_view)
    ], 2),
    _createVNode(_component_p_toast),
    _createVNode(_component_app_fullscreen_spinner),
    _createVNode(_component_app_company_status_dialog)
  ], 64))
}